import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  _Dimension___get_value__impl__urhqzr1mx919605mj8b as _Dimension___get_value__impl__urhqzr,
  _Dimension___init__impl__44fy0d337h17ibt02iy as _Dimension___init__impl__44fy0d,
} from './data.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  mapOf2zpbbmyqk8xpf as mapOf,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  emptyMapr06gerzljqtm as emptyMap,
  plus2m1vv33moko5t as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  PerCorner27xb33zgvi5gv as PerCorner,
  RatioOfSpacing2du8cst35dyuc as RatioOfSpacing,
  RatioOfSize1ip5bd7oxn8ba as RatioOfSize,
  ForceConstant11m1vt5jr2l8f as ForceConstant,
  Constant5dc3leeorpdb as Constant,
} from './CornerRadii.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  RadialGradient3ic79yys0k1fp as RadialGradient,
  LinearGradient2qftccjwl6uey as LinearGradient,
  Companion_getInstancenv8qpb0wanrh as Companion_getInstance,
  Color17ck47lkedxoy as Color,
  FadingColor3d6ef6zcqmlhk as FadingColor,
} from './Paint.mjs';
import { _Angle___get_turns__impl__atdtw5dv920nekm6fo as _Angle___get_turns__impl__atdtw5 } from './Angle.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_rem(_this__u8e3s4) {
  return Dimension(VOID, _this__u8e3s4);
}
var FontClass;
function Font() {
  if (FontClass === VOID) {
    class $ {
      constructor(cssFontFamilyName, url, fallback, direct) {
        url = url === VOID ? null : url;
        fallback = fallback === VOID ? 'Helvetica' : fallback;
        direct = direct === VOID ? null : direct;
        this.hax_1 = cssFontFamilyName;
        this.iax_1 = url;
        this.jax_1 = fallback;
        this.kax_1 = direct;
      }
      toString() {
        return 'Font(cssFontFamilyName=' + this.hax_1 + ', url=' + this.iax_1 + ', fallback=' + this.jax_1 + ', direct=' + toString(this.kax_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.hax_1);
        result = imul(result, 31) + (this.iax_1 == null ? 0 : getStringHashCode(this.iax_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.jax_1) | 0;
        result = imul(result, 31) + (this.kax_1 == null ? 0 : this.kax_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Font()))
          return false;
        if (!(this.hax_1 === other.hax_1))
          return false;
        if (!(this.iax_1 == other.iax_1))
          return false;
        if (!(this.jax_1 === other.jax_1))
          return false;
        if (!equals(this.kax_1, other.kax_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Font');
    FontClass = $;
  }
  return FontClass;
}
function get_systemDefaultFont() {
  return new (Font())("'Montserrat'", 'https://fonts.googleapis.com/css2?family=Montserrat:wght@100;400;700&display=swap', 'Helvetica');
}
function get_px(_this__u8e3s4) {
  return Dimension(_this__u8e3s4);
}
function get_rem_0(_this__u8e3s4) {
  return Dimension(VOID, _this__u8e3s4);
}
function times(_this__u8e3s4, other) {
  return Dimension(_Dimension___get_value__impl__urhqzr(_this__u8e3s4).lax_1 * other, _Dimension___get_value__impl__urhqzr(_this__u8e3s4).max_1 * other);
}
function plus_0(_this__u8e3s4, other) {
  return Dimension(_Dimension___get_value__impl__urhqzr(_this__u8e3s4).lax_1 + _Dimension___get_value__impl__urhqzr(other).lax_1, _Dimension___get_value__impl__urhqzr(_this__u8e3s4).max_1 + _Dimension___get_value__impl__urhqzr(other).max_1);
}
function get_dp(_this__u8e3s4) {
  return Dimension(_this__u8e3s4);
}
function div(_this__u8e3s4, other) {
  return Dimension(_Dimension___get_value__impl__urhqzr(_this__u8e3s4).lax_1 / other, _Dimension___get_value__impl__urhqzr(_this__u8e3s4).max_1 / other);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.nax_1 = new (DimensionRaw())();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var DimensionRawClass;
function DimensionRaw() {
  if (DimensionRawClass === VOID) {
    class $ {
      constructor(px, rem) {
        Companion_getInstance_0();
        px = px === VOID ? 0.0 : px;
        rem = rem === VOID ? 0.0 : rem;
        this.lax_1 = px;
        this.max_1 = rem;
      }
      oax() {
        return this.lax_1 + this.max_1 * 16;
      }
      toString() {
        return this.lax_1 === 0.0 ? '' + this.max_1 + 'rem' : this.max_1 === 0.0 ? '' + this.lax_1 + 'px' : 'calc(' + this.lax_1 + 'px + ' + this.max_1 + 'rem)';
      }
      pax(other) {
        return compareTo(this.oax(), other.oax());
      }
      d(other) {
        return this.pax(other instanceof DimensionRaw() ? other : THROW_CCE());
      }
      hashCode() {
        var result = getNumberHashCode(this.lax_1);
        result = imul(result, 31) + getNumberHashCode(this.max_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DimensionRaw()))
          return false;
        if (!equals(this.lax_1, other.lax_1))
          return false;
        if (!equals(this.max_1, other.max_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DimensionRaw', DimensionRaw, VOID, [Comparable()]);
    DimensionRawClass = $;
  }
  return DimensionRawClass;
}
var ImageSourceClass;
function ImageSource() {
  if (ImageSourceClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ImageSource');
    ImageSourceClass = $;
  }
  return ImageSourceClass;
}
function translate($this, dir, from, to_0) {
  return new (ScreenTransitionPart())(mapOf(to('transform', 'translate' + dir + '(' + from + '%)')), mapOf(to('transform', 'translate' + dir + '(' + to_0 + '%)')));
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.collections.mapOf' call
        var tmp_0 = emptyMap();
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$1 = emptyMap();
        var tmp_1 = new (ScreenTransitionPart())(tmp_0, tmp$ret$1);
        // Inline function 'kotlin.collections.mapOf' call
        var tmp_2 = emptyMap();
        // Inline function 'kotlin.collections.mapOf' call
        var tmp$ret$3 = emptyMap();
        tmp.qax_1 = new (ScreenTransition())('None', tmp_1, new (ScreenTransitionPart())(tmp_2, tmp$ret$3));
        this.rax_1 = new (ScreenTransition())('Push', translate(this, 'X', 100, 0), translate(this, 'X', 0, -100));
        this.sax_1 = new (ScreenTransition())('Pop', translate(this, 'X', -100, 0), translate(this, 'X', 0, 100));
        this.tax_1 = new (ScreenTransition())('PullUp', translate(this, 'Y', 100, 0), translate(this, 'Y', 0, -100));
        this.uax_1 = new (ScreenTransition())('PullDown', translate(this, 'Y', -100, 0), translate(this, 'Y', 0, 100));
        this.vax_1 = new (ScreenTransition())('Fade', new (ScreenTransitionPart())(mapOf(to('opacity', '0')), mapOf(to('opacity', '1'))), new (ScreenTransitionPart())(mapOf(to('opacity', '1')), mapOf(to('opacity', '0'))));
        this.wax_1 = (new (ScreenTransition())('Grow', new (ScreenTransitionPart())(mapOf(to('transform', 'scale(0.75) translateY(7vh)')), mapOf(to('transform', 'scale(1.0) translateY(0)'))), new (ScreenTransitionPart())(mapOf(to('transform', 'scale(1.00) translateY(0)')), mapOf(to('transform', 'scale(1.33) translateY(-7vh)'))))).bay(this.vax_1);
        this.xax_1 = (new (ScreenTransition())('Shrink', new (ScreenTransitionPart())(mapOf(to('transform', 'scale(1.33) translateY(-7vh)')), mapOf(to('transform', 'scale(1.0) translateY(0)'))), new (ScreenTransitionPart())(mapOf(to('transform', 'scale(1.0) translateY(0vh)')), mapOf(to('transform', 'scale(0.75) translateY(7vh)'))))).bay(this.vax_1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var ScreenTransitionClass;
function ScreenTransition() {
  if (ScreenTransitionClass === VOID) {
    class $ {
      constructor(name, enter, exit) {
        Companion_getInstance_1();
        this.yax_1 = name;
        this.zax_1 = enter;
        this.aay_1 = exit;
      }
      bay(other) {
        return new (ScreenTransition())(this.yax_1 + other.yax_1, this.zax_1.eay(other.zax_1), this.aay_1.eay(other.aay_1));
      }
    }
    initMetadataForClass($, 'ScreenTransition');
    ScreenTransitionClass = $;
  }
  return ScreenTransitionClass;
}
function Dimension(px, rem) {
  px = px === VOID ? 0.0 : px;
  rem = rem === VOID ? 0.0 : rem;
  return _Dimension___init__impl__44fy0d(new (DimensionRaw())(px, rem));
}
var FontDirectClass;
function FontDirect() {
  if (FontDirectClass === VOID) {
    class $ {
      constructor(normal, italics) {
        this.fay_1 = normal;
        this.gay_1 = italics;
      }
      toString() {
        return 'FontDirect(normal=' + toString_0(this.fay_1) + ', italics=' + toString_0(this.gay_1) + ')';
      }
      hashCode() {
        var result = hashCode(this.fay_1);
        result = imul(result, 31) + hashCode(this.gay_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FontDirect()))
          return false;
        if (!equals(this.fay_1, other.fay_1))
          return false;
        if (!equals(this.gay_1, other.gay_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'FontDirect');
    FontDirectClass = $;
  }
  return FontDirectClass;
}
var ScreenTransitionPartClass;
function ScreenTransitionPart() {
  if (ScreenTransitionPartClass === VOID) {
    class $ {
      constructor(from, to) {
        this.cay_1 = from;
        this.day_1 = to;
      }
      eay(other) {
        return new (ScreenTransitionPart())(plus(this.cay_1, other.cay_1), plus(this.day_1, other.day_1));
      }
    }
    initMetadataForClass($, 'ScreenTransitionPart');
    ScreenTransitionPartClass = $;
  }
  return ScreenTransitionPartClass;
}
function minus(_this__u8e3s4, other) {
  return Dimension(_Dimension___get_value__impl__urhqzr(_this__u8e3s4).lax_1 - _Dimension___get_value__impl__urhqzr(other).lax_1, _Dimension___get_value__impl__urhqzr(_this__u8e3s4).max_1 - _Dimension___get_value__impl__urhqzr(other).max_1);
}
function toRawCornerRadius(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Constant()) {
    tmp = 'calc(min(var(--parentSpacing, 0px), ' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.pay_1).toString() + '))';
  } else {
    if (_this__u8e3s4 instanceof ForceConstant()) {
      tmp = _Dimension___get_value__impl__urhqzr(_this__u8e3s4.oay_1).toString();
    } else {
      if (_this__u8e3s4 instanceof RatioOfSize()) {
        tmp = '' + numberToInt(_this__u8e3s4.nay_1 * 100) + '%';
      } else {
        if (_this__u8e3s4 instanceof RatioOfSpacing()) {
          tmp = 'calc(var(--parentSpacing, 0px) * ' + _this__u8e3s4.may_1 + ')';
        } else {
          if (_this__u8e3s4 instanceof PerCorner()) {
            var tmp_0 = listOf([_this__u8e3s4.iay_1, _this__u8e3s4.jay_1, _this__u8e3s4.lay_1, _this__u8e3s4.kay_1]);
            tmp = joinToString(tmp_0, ' ', VOID, VOID, VOID, VOID, (it) => it ? _Dimension___get_value__impl__urhqzr(_this__u8e3s4.hay_1).toString() : '0px');
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
  }
  return tmp;
}
var ImageResourceClass;
function ImageResource() {
  if (ImageResourceClass === VOID) {
    class $ extends ImageSource() {
      constructor(relativeUrl) {
        super();
        this.qay_1 = relativeUrl;
      }
      toString() {
        return 'ImageResource(relativeUrl=' + this.qay_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.qay_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ImageResource()))
          return false;
        if (!(this.qay_1 === other.qay_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ImageResource');
    ImageResourceClass = $;
  }
  return ImageResourceClass;
}
function get_dp_0(_this__u8e3s4) {
  return Dimension(_this__u8e3s4);
}
function get_systemDefaultFixedWidthFont() {
  return new (Font())('monospace');
}
function vectorToSvgDataUrl(_this__u8e3s4) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().d1();
  this_0.wb('<?xml version="1.0" encoding="UTF-8"?>');
  this_0.wb('<svg xmlns="http://www.w3.org/2000/svg" width="' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.ray_1).toString() + '" height="' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.say_1).toString() + '" viewBox="' + _this__u8e3s4.tay_1 + ' ' + _this__u8e3s4.uay_1 + ' ' + _this__u8e3s4.vay_1 + ' ' + _this__u8e3s4.way_1 + '">');
  this_0.wb('<defs>');
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = _this__u8e3s4.xay_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var p = item.yay_1;
    if (p instanceof LinearGradient()) {
      // Inline function 'com.lightningkite.kiteui.models.Angle.degrees' call
      var this_1 = p.naz_1;
      var tmp$ret$0 = _Angle___get_turns__impl__atdtw5(this_1) * 360.0;
      this_0.wb('<linearGradient id="fill' + index_0 + '" gradientTransform="rotate(' + tmp$ret$0 + ', 0.5, 0.5)">');
      var _iterator__ex2g4s_0 = p.maz_1.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var stop = _iterator__ex2g4s_0.o1();
        this_0.wb('<stop stop-color="' + stop.gaz_1.laz() + '" stop-opacity="' + stop.gaz_1.haz_1 + '" offset="' + numberToInt(stop.faz_1 * 100) + '%"/>');
      }
      this_0.wb('<\/linearGradient>');
    } else {
      if (p instanceof RadialGradient()) {
        this_0.wb('<radialGradient id="fill' + index_0 + '">');
        var _iterator__ex2g4s_1 = p.daz_1.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var stop_0 = _iterator__ex2g4s_1.o1();
          this_0.wb('<stop stop-color="' + stop_0.gaz_1.laz() + '" stop-opacity="' + stop_0.gaz_1.haz_1 + '" offset="' + numberToInt(stop_0.faz_1 * 100) + '%"/>');
        }
        this_0.wb('<\/radialGradient>');
      }
    }
  }
  this_0.wb('<\/defs>');
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index_1 = 0;
  var _iterator__ex2g4s_2 = _this__u8e3s4.xay_1.m1();
  while (_iterator__ex2g4s_2.n1()) {
    var item_0 = _iterator__ex2g4s_2.o1();
    var _unary__edvuaz_0 = index_1;
    index_1 = _unary__edvuaz_0 + 1 | 0;
    var index_2 = checkIndexOverflow(_unary__edvuaz_0);
    var tmp0_safe_receiver = item_0.zay_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.paz();
    var tmp = tmp1_elvis_lhs == null ? Companion_getInstance().qaz_1.paz() : tmp1_elvis_lhs;
    var tmp2_elvis_lhs = item_0.aaz_1;
    var tmp_0 = toString_0(tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var f = item_0.yay_1;
    var tmp_1;
    if (f instanceof LinearGradient()) {
      tmp_1 = 'url(#fill' + index_2 + ')';
    } else {
      if (f instanceof RadialGradient()) {
        tmp_1 = 'url(#fill' + index_2 + ')';
      } else {
        if (f instanceof FadingColor()) {
          tmp_1 = f.bb0_1.paz();
        } else {
          if (f instanceof Color()) {
            tmp_1 = f.paz();
          } else {
            tmp_1 = Companion_getInstance().qaz_1.paz();
          }
        }
      }
    }
    this_0.wb('<path fill-rule="evenodd" d="' + item_0.caz_1 + '" stroke="' + tmp + '" stroke-width="' + tmp_0 + '" fill="' + tmp_1 + '"/>');
  }
  this_0.wb('<\/svg>');
  var tmp$ret$7 = this_0.toString();
  return 'data:image/svg+xml;utf8,' + encodeURIComponent(tmp$ret$7);
}
//region block: exports
export {
  FontDirect as FontDirect3ifj3qs5hfije,
  Font as Font1uq8v2r7qm3xe,
  ImageResource as ImageResource1861inqz1dzjl,
  ImageSource as ImageSource1gw5x4v78u21a,
  div as divc3x3x4wqw206,
  get_dp as get_dp28ag147e4p5cz,
  get_dp_0 as get_dp246mt9ygxfnpl,
  minus as minus1paei8txflgx9,
  plus_0 as plus2opbwe063z9pg,
  get_px as get_px8ok5q0jdway2,
  get_rem as get_rem14pbkv8p42gid,
  get_rem_0 as get_rem2p56fiaxda5jo,
  get_systemDefaultFixedWidthFont as get_systemDefaultFixedWidthFont14cv3wy0prdkq,
  get_systemDefaultFont as get_systemDefaultFont25t9j5zn5vlep,
  times as times16x024lmmohdt,
  toRawCornerRadius as toRawCornerRadius2lzu7hpq9jr9l,
  vectorToSvgDataUrl as vectorToSvgDataUrl2gfp16zcspd2w,
  Companion_getInstance_0 as Companion_getInstance1pd09epsgyyke,
  Companion_getInstance_1 as Companion_getInstance33aui7uk8ap15,
};
//endregion

//# sourceMappingURL=data.commonHtml.mjs.map
